export default function getIsAdminFromResponse(action) {
  if (typeof action.response.currentUserIsAdmin === "boolean") {
    return action.response.currentUserIsAdmin
  }

  const currentOrganization = action.response.organizations.filter(
    (org) => org.id === action.response.customer.id,
  )?.[0]

  if (!currentOrganization) {
    return false
  }
  const { currentUser } = action.response
  return (
    currentUser.wavelengthEmployee ||
    currentUser?.organizationSettings?.isAdmin[currentOrganization.id]
  )
}
